import {METAMASK,BLOCKCHAINCONTRACT} from './constants'

/*** ACTION DEFINATION FOR SET METAMASK cred ***/
export const setMetaMask = (obj) => {
    //console.log('in action',obj)
    const action = {
        type : METAMASK,
        data : obj
    }
    return action
}
/*** ACTION DEFINATION FOR SET METAMASK cred ***/
export const setBlockChainContract = (param) => {
    const action = {
        type : BLOCKCHAINCONTRACT,
        data : param
    }
    return action
}

